var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ButtonBorderedKVBase, ButtonKVBase, CircleSpinner, ImageLazyAvatar, InputKVBase } from '@/presentation/components';
import { IconCircleColorCheck, IconOne, IconTwo } from '@/presentation/components/icons';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { studentFirstLoginAtom } from './components/atoms';
import Styles from './student-first-login-styles.scss';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { useNavigate } from 'react-router';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { ETHNICITY } from '@/presentation/constants/ethnicity';
import { GENDER } from '@/presentation/constants/gender';
import { Select } from './components';
import { createValueDefinitionString } from '@/presentation/functions/value-definition-utils';
import AvatarModalWrapper from '@/presentation/components/avatar-modal/avatar-modal';
import { extractAvatarIdFromUrl, getUrlAvatarFromUrlObject } from '@/main/utils/avatar-utils';
import { scrollToTop } from '@/main/utils/scroll-utils';
import { isMobile } from 'mobile-device-detect';
const StudentFirstLogin = ({ validation, manageUsers }) => {
    const [step, setStep] = useState(0);
    const [state, setState] = useRecoilState(studentFirstLoginAtom);
    const { user } = useUserSesssion();
    const { showCustomSuccess, showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const saveUserData = (photoUrlParam) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            let ethnicity = state === null || state === void 0 ? void 0 : state.ethnicity;
            if (!ethnicity) {
                ethnicity = {
                    value: '27',
                    label: 'Other'
                };
            }
            let gender = state === null || state === void 0 ? void 0 : state.gender;
            if (!gender) {
                gender = {
                    value: '19',
                    label: 'Not Specified'
                };
            }
            const dateStr = state.dateOfBirthday;
            const dateOfBirthday = new Date(Date.parse(dateStr));
            const studentUpdated = yield manageUsers.update({
                id: user.id,
                username: state.username || null,
                gender: createValueDefinitionString(gender === null || gender === void 0 ? void 0 : gender.value),
                dateOfBirthday,
                ethnicity: createValueDefinitionString(ethnicity === null || ethnicity === void 0 ? void 0 : ethnicity.value),
                photoUrl: photoUrlParam || null
            });
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
            if (studentUpdated) {
                showCustomSuccess('OK', 'User data updated');
                return true;
            }
            showCustomError('Error', 'Error updating user data');
            return false;
        }
        catch (e) {
            console.log(e);
            showCustomError('Error', 'Error updating user data');
            return false;
        }
    });
    return (React.createElement("div", { style: { height: '100vh', width: '100vw' } },
        React.createElement(Container, { className: Styles.mainWrap },
            !isMobile ? (React.createElement("div", { className: Styles.header },
                React.createElement("div", { className: "d-flex justify-content-center align-items-center" },
                    React.createElement("div", { className: Styles.iconWrap }, step === 0 ? React.createElement(IconOne, null) : React.createElement(IconCircleColorCheck, null)),
                    React.createElement("div", { className: Styles.text, style: { color: step === 0 ? '#000' : '#999' } }, "Personal Information")),
                React.createElement("div", { className: "d-flex justify-content-center align-items-center" },
                    React.createElement("div", { className: Styles.iconWrap },
                        React.createElement(IconTwo, { color: step === 1 ? '#000' : '#999' })),
                    React.createElement("div", { className: Styles.text, style: { color: step === 1 ? '#000' : '#999' } }, "Create Your Avatar")))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: Styles.stepContainer },
                    step === 0 ? 1 : 2,
                    "/2"),
                React.createElement("div", { className: Styles.stepInfo }, step === 0 ? 'Personal Information' : 'Create Your Avatar'))),
            React.createElement("div", { className: "d-flex justify-content-center align-items-center p-5" },
                step === 0 && (React.createElement(Step1Page, { step: step, setStep: setStep, validation: validation, manageUsers: manageUsers, saveUserData: saveUserData })),
                step === 1 && (React.createElement(Step2Page, { step: step, setStep: setStep, validation: validation, manageUsers: manageUsers, saveUserData: saveUserData }))))));
};
const Step1Page = ({ step, setStep, validation, manageUsers, saveUserData }) => {
    const [state, setState] = useRecoilState(studentFirstLoginAtom);
    const resetState = useResetRecoilState(studentFirstLoginAtom);
    const validate = (field) => {
        const { dateOfBirthday, gender, ethnicity, username } = state;
        const formData = { dateOfBirthday, gender, ethnicity, username };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validation.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.dateOfBirthdayError || !!prev.genderError || !!prev.ethnicityError || !!prev.usernameError })));
    };
    const isFormEmpty = () => {
        var _a, _b;
        return state.dateOfBirthday === '' || !((_a = state === null || state === void 0 ? void 0 : state.gender) === null || _a === void 0 ? void 0 : _a.value) || !((_b = state === null || state === void 0 ? void 0 : state.ethnicity) === null || _b === void 0 ? void 0 : _b.value);
    };
    useEffect(() => {
        if (state.dateOfBirthday)
            validate('dateOfBirthday');
    }, [state.dateOfBirthday]);
    useEffect(() => {
        if (state.gender)
            validate('gender');
    }, [state.gender]);
    useEffect(() => {
        if (state.ethnicity)
            validate('ethnicity');
    }, [state.ethnicity]);
    useEffect(() => {
        if (state.username)
            validate('username');
        else
            setState(prev => (Object.assign(Object.assign({}, prev), { usernameError: '', dirtyFields: { username: false } })));
    }, [state.username]);
    useEffect(() => {
        resetState();
    }, []);
    const goStep2 = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (((_a = state === null || state === void 0 ? void 0 : state.username) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            const isAvailableUsername = yield manageUsers.isUsernameAvailable(state.username);
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
            if (isAvailableUsername) {
                // save data ...
                const res = yield saveUserData();
                if (res)
                    setStep(1);
            }
            else {
                setState(prev => (Object.assign(Object.assign({}, prev), { usernameError: 'Username is not available', dirtyFields: { username: true } })));
            }
        }
        else {
            // save data ...
            const res = yield saveUserData();
            if (res)
                setStep(1);
        }
    });
    return (React.createElement("div", { className: classNames('d-flex justify-content-center align-items-center', Styles.step1Page) },
        React.createElement("div", { className: Styles.title }, "Welcome to KidVestors!"),
        React.createElement("div", { className: Styles.subtitle }, "Please, complete your profile"),
        React.createElement(Row, { className: Styles.row },
            React.createElement(Col, { xs: 12, md: 12, className: "d-flex justify-content-center align-items-center" },
                React.createElement(InputKVBase, { type: "text", name: "username", placeholder: "Optional", label: "Username", state: state, setState: setState, defaultValue: state.username }))),
        React.createElement(Row, { className: Styles.row },
            React.createElement(Col, { xs: 12, md: 6, className: "d-flex justify-content-center align-items-center" },
                React.createElement(InputKVBase, { type: "date", name: "dateOfBirthday", placeholder: "MM/DD/YYYY", label: "DOB", state: state, setState: setState, required: true, defaultValue: state.dateOfBirthday })),
            React.createElement(Col, { xs: 12, md: 6, className: "d-flex justify-content-center align-items-center" },
                React.createElement(Select, { name: "gender", required: true, label: "Gender", placeholder: 'Select an option', options: GENDER.map(item => ({
                        value: `${item.value}`,
                        label: `${item.label}`
                    })) }))),
        React.createElement(Row, { className: Styles.row },
            React.createElement(Col, { xs: 12, md: 12, className: "d-flex justify-content-center align-items-center" },
                React.createElement(Select, { name: "ethnicity", label: "Ethnicity", required: true, options: ETHNICITY.map(item => ({
                        value: `${item.value}`,
                        label: `${item.label}`
                    })), placeholder: 'Select an option' }))),
        React.createElement("br", null),
        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: goStep2, disabled: state.isFormInvalid || isFormEmpty(), loading: state.isLoading }, "Continue")));
};
const Step2Page = ({ saveUserData, setStep }) => {
    const [state, setState] = useRecoilState(studentFirstLoginAtom);
    const navigate = useNavigate();
    const [openAvatarModal, setOpenAvatarModal] = useState(false);
    const [urlAvatar3D, setUrlAvatar3D] = useState(null);
    const [urlAvatar3DLoader, setUrlAvatar3DLoader] = useState(true);
    const [loading, setLoading] = useState(false);
    const handleOnAvatarExported = (url) => setUrlAvatar3D(url);
    const { updateUserSession } = useUserSesssion();
    const updateUserAndContinue = () => __awaiter(void 0, void 0, void 0, function* () {
        const photoUrl = extractAvatarIdFromUrl(urlAvatar3D);
        const res = yield saveUserData(photoUrl);
        setLoading(true);
        if (res) {
            // reload user data
            const flag = yield updateUserSession();
            if (flag)
                navigate('/student-dashboard/home');
        }
        setLoading(false);
    });
    useEffect(() => {
        scrollToTop();
        setTimeout(() => {
            setOpenAvatarModal(true);
            setUrlAvatar3DLoader(false);
        }, 1000);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames('d-flex justify-content-center align-items-center', Styles.step2Page) },
            urlAvatar3D ? (React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setOpenAvatarModal(true) },
                React.createElement(ImageLazyAvatar, { alt: "Avatar", src: getUrlAvatarFromUrlObject(urlAvatar3D), width: 450 }))) : urlAvatar3DLoader ? (React.createElement(CircleSpinner, null)) : (React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setOpenAvatarModal(true) },
                React.createElement("b", null, "No avatar created"))),
            React.createElement("div", { className: "d-flex py-5 w-100", style: { alignItems: 'center', justifyContent: 'space-around' } },
                React.createElement("div", null,
                    React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => setStep(0) }, "Back")),
                React.createElement("div", null,
                    React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: updateUserAndContinue, loading: state.isLoading || loading }, "Continue")))),
        React.createElement(AvatarModalWrapper, { openModal: openAvatarModal, setOpenModal: setOpenAvatarModal, handleOnAvatarExported: handleOnAvatarExported })));
};
export default StudentFirstLogin;
